module.exports = __webpack_public_path__ + "static/img/section01-02@m.f58e3e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/serveone-renewal/section01-02@m.jpg
// module id = jAgM
// module chunks = 0